<template>
  <div v-if="categoria" ref="root" class="relative inline-flex">
    <button
      type="button"
      @click.stop="toggle"
      :title="`${tierName} — desconto de taxa ${descontoLabel}`"
      :aria-label="`Categoria ${tierName}, desconto de taxa ${descontoLabel}`"
      class="inline-flex items-center justify-center rounded-full p-1 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/40 transition-colors"
    >
      <!-- Coroa -->
      <svg
        viewBox="0 0 24 24"
        class="h-6 w-6 drop-shadow"
        :style="{ color: tierColor }"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          d="M3 7l4.5 3.5L12 4l4.5 6.5L21 7l-1.6 10.2a1 1 0 0 1-1 .8H5.6a1 1 0 0 1-1-.8L3 7z"
        />
        <rect x="4.5" y="19" width="15" height="2.2" rx="1" />
      </svg>
    </button>

    <!-- Popover com o percentual -->
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="open"
        class="absolute right-0 top-full mt-2 z-30 w-48 rounded-lg bg-white p-3 text-left shadow-xl ring-1 ring-black/5"
      >
        <div class="flex items-center gap-2">
          <span
            class="inline-block h-3 w-3 rounded-full flex-shrink-0"
            :style="{ backgroundColor: tierColor }"
          ></span>
          <span class="text-sm font-semibold text-gray-900">{{
            tierName
          }}</span>
        </div>
        <p class="mt-1 text-xs text-gray-500">
          Desconto de taxa:
          <strong class="text-gray-800">{{ descontoLabel }}</strong>
        </p>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

const TIER_COLORS: Record<string, string> = {
  ouro: "#EAB308",
  prata: "#9CA3AF",
  bronze: "#CD7F32",
  ferro: "#64748B",
};

const TIER_COLORS_BY_ID: Record<number, string> = {
  1: "#EAB308", // Ouro
  2: "#9CA3AF", // Prata
  3: "#CD7F32", // Bronze
  4: "#64748B", // Ferro
};

export default defineComponent({
  name: "ResaleCategoryBadge",
  props: {
    categoria: {
      type: Object as () => {
        id?: number | null;
        nome?: string | null;
        descricao?: string | null;
        percentual_desconto?: number | null;
      } | null,
      default: null,
    },
  },
  data() {
    return { open: false };
  },
  computed: {
    tierName(): string {
      if (this.categoria?.nome) return this.categoria.nome;
      if (this.categoria?.id != null) return `Categoria #${this.categoria.id}`;
      return "Não definida";
    },
    tierColor(): string {
      const nome = this.categoria?.nome?.toLowerCase();
      if (nome && TIER_COLORS[nome]) return TIER_COLORS[nome];
      const id = this.categoria?.id;
      if (id != null && TIER_COLORS_BY_ID[id]) return TIER_COLORS_BY_ID[id];
      return "#9CA3AF";
    },
    descontoLabel(): string {
      const p = this.categoria?.percentual_desconto;
      return p != null ? `${(p * 100).toFixed(0)}%` : "—";
    },
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.close);
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
  },
});
</script>
